import { createDocument, getAllData } from "apis/customApiHandler";
import toast from "react-hot-toast";
import Spinner from "components/Spinner";
import { Fragment, useCallback, useEffect, useState } from "react";
import { BiCloudDownload } from "react-icons/bi";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import Modal from "components/Modal";
import { Input, Select } from "styled";
import { TD, TH } from "styled/table";
import exportExcel from "utils/exportExcel";
import {Button} from 'styled'
import getFormattedDate from "utils/helpers";
let allMonths = [
  "",
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

const contractTypeOptions = [
  { value: 'All', label: 'All' },
  { value: 'CPKM', label: 'CPKM' },
  { value: 'NON CPKM', label: 'NON CPKM' },
  { value: 'DE-ENROLLED', label: 'De-enrolled' }
];

const InspectionDetailsInLastFourMonths = () => {
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [fleetMap, setFleetMap] = useState({});
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [reportData, setReportData] = useState("")
  const [downloading, setDownloading] = useState(false)
  const [enabled, setEnabled] = useState(false)
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [contractType, setContractType] = useState("")
  const [reportType , setReportType] = useState('fleet')
  const [showHubColumn, setShowHubColumn] = useState(false);
  const [searchPayload, setSearchPayload] = useState({});

  const getData = async ()=>{
    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      setData([]);
      return;
    }
    setIsLoading(true)
    let payload = {
      ...(selectedFleets?.includes("all")
        ? {
          fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
      ...(selectedHubs?.includes("all")
        ? {
            hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),
      ...(dateFrom && {
        dateFrom,
      }),
      ...(dateTo && {
        dateTo,
      }),
      reportType,
      contractType: contractType || ""
    }
    const dt = await createDocument("/report/inspectionDetailsInLastFourMonths", payload)

    console.log("DATA---", dt);
    setSearchPayload(payload)
    setShowHubColumn(reportType === "hub");
    setData(dt);
    setIsLoading(false)
  }

  console.log(data)

  const months = data?.dateRange;
  const actualdata = data?.groups;

  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );

  const getDownloadData = async () => {
    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      setData([]);
      return;
    }
    setDownloading(true);
    try {
      const dt = await createDocument(
        "/report/inspectionDetailsInLastFourMonths",
        {
          ...(selectedFleets?.includes("all")
            ? {
                fleets: getFleetOptions()
                  .filter(
                    (item) => item.value !== "all" && item.value !== "clear"
                  )
                  .map((item) => item.value)
                  .join(","),
              }
            : selectedFleets.length && {
                fleets: selectedFleets.map((fleet) => fleet).join(","),
              }),
          ...(selectedHubs?.includes("all")
            ? {
                hubs: getHubOptions()
                  .filter(
                    (item) => item.value !== "all" && item.value !== "clear"
                  )
                  .map((item) => item.value)
                  .join(","),
              }
            : selectedHubs.length && {
                hubs: selectedHubs.map((hub) => hub).join(","),
              }),
          ...(dateFrom && {
            dateFrom,
          }),
          ...(dateTo && {
            dateTo,
          }),
          reportType,
          ...(contractType && { contractType }),
        }
      );
      // console.log(dt)

      let exportData = dt?.inspections?.map((x, idx) => {
        let monthData = {};
        const months = data?.dateRange;
        // console.log(x)
        data?.dateRange?.map((month) => {
          const dt = `${allMonths[parseInt(month.split("-")[0])]}-${
            month.split("-")[1]
          }`;
          monthData = { ...monthData, [dt]: x[month] ?? 0 };
        });
        return {
          "S.N": idx + 1,
          "Fleet Name": `${x?.fleet} (${x?.fleetCity || "-"})`,
          ...(showHubColumn ? { "Hub Name": x?.hubName } : {}),
          "Enrolled Vehicles": x?.enrolledVehicles ?? 0,
          ...monthData,
          "Inspection %": (() => {
            const lastMonthCount = x[months?.slice(-1)?.[0]] ?? 0;
            const denominator =
              x?.enrolledVehicles || dt.fleetEnrolledMap[x?.fleetId] || 0;
            if (!lastMonthCount || !denominator) return "0.00";
            const pct = (lastMonthCount / denominator) * 100;
            return pct > 100 ? "100.00" : pct.toFixed(2);
          })(),
          "Total Vehicles": x?.totalVehicles ?? 0,
        };
      });

      let totalRow = {
        "SL No": "Total",
        "Enrolled Vehicles": dt.totalRow.enrolledVehicles ?? dt.totalRow.vehicleCount ?? 0,
      };
      data?.dateRange?.map((month) => {
        const monthString = `${allMonths[parseInt(month.split("-")[0])]}-${
          month.split("-")[1]
        }`;
        console.log(month, dt.totalRow)
        totalRow[monthString] = dt.totalRow[month];
      });
      totalRow["Inspection %"] = parseFloat(dt.totalRow.averagePercent) > 100
  ? "100"
  : dt.totalRow.averagePercent;
      totalRow["Total Vehicles"] = dt.totalRow.totalVehicles ?? 0;

      exportData.push(totalRow);
      console.log(totalRow)

      exportExcel(exportData, `inspection-trend-report-${reportType}-wise`, true);
    } catch {
    } finally {
      setDownloading(false);
    }
  };

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
       ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }]: [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }]: [],
        ...(selectedFleets?.includes("all") ? 
        allHubs?.data?.length &&
          allHubs?.data
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            }) : 
        allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  console.log('showHubColumn--',showHubColumn);

  return (
    <div>
      <div>
        <div className="w-full px-8 flex justify-center mt-4 items-center gap-4">
          <label className="w-full ">
            Select Fleets
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getFleetOptions()}
              value={
                selectedFleets &&
                selectedFleets?.map((fleet) => {
                  return {
                    value: fleet,
                    label: getFleetOptions()?.find(
                      (item) => item?.value === fleet
                    )?.label,
                  };
                })
              }
              onChange={(value) => {
                let allValues = value?.map((item) => item.value);
                if (allValues?.includes("clear")) {
                  // console.log(allValues)
                  setSelectedFleets([]);
                  setSelectedHubs([]);
                  return;
                }
                if (
                  !selectedFleets?.includes("all") &&
                  allValues.includes("all")
                ) {
                  setSelectedFleets(["all"]);
                  return;
                }

                if (selectedFleets.includes("all")) {
                  // console.log("first");
                  // console.log(getFleetOptions())
                  value = value.filter((item) => item.value !== "all");
                }

                let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                  value?.map((item) => item.value)?.includes(fleet._id)
                );

                let selectedHubsVal = allHubs?.data?.filter((hub) =>
                  selectedHubs?.map((item) => item)?.includes(hub._id)
                );

                setSelectedHubs(
                  selectedHubsVal
                    ?.filter((hub) =>
                      selectedFleetsVal?.find(
                        (fleet) => fleet.fleetCode === hub.fleetCode
                      )
                    )
                    .map((hub) => hub._id)
                );

                // console.log({allHubs, selectedHubs})

                setSelectedFleets(value.map((fleet) => fleet.value));
              }}
              name="fleets"
              isMulti={true}
            />
          </label>
          <label className="w-full ">
            Select Hubs
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getHubOptions()}
              value={
                selectedHubs &&
                selectedHubs?.map((hub) => {
                  // console.log({hub})
                  return {
                    value: hub,
                    label: getHubOptions()?.find((item) => item.value === hub)
                      ?.label,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);
                // console.log({allValues})
                if (allValues.includes("clear")) {
                  setSelectedHubs([]);
                  return;
                }
                if (
                  !selectedHubs?.includes("all") &&
                  allValues.includes("all")
                ) {
                  let selectedFleetCodes = allFleets?.data
                    ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                    ?.map((fleet) => fleet.fleetCode);

                  const selectedHubsData = allHubs?.data?.filter((hub) =>
                    selectedFleetCodes?.includes(hub.fleetCode)
                  );

                  const mp = fleetMap;
                  selectedHubsData.map((hub) => {
                    if (selectedFleetCodes?.includes(hub.fleetCode)) {
                      if (mp[hub.fleetCode] === undefined)
                        mp[hub.fleetCode] = [];
                      mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                    }
                  });

                  setFleetMap(mp);
                  setSelectedHubs(["all"]);
                } else {
                  // console.log({value})
                  value = value.filter((value) => value.value !== "all");
                  // console.log({value})
                  let selectedFleetCodes = allFleets?.data
                    ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                    ?.map((fleet) => fleet.fleetCode);
                  // console.log({allValues})

                  const selectedHubsData = allHubs?.data?.filter((hub) =>
                    allValues?.includes(hub._id)
                  );
                  const mp = {};
                  selectedHubsData.map((hub) => {
                    mp[hub.fleetCode] = [];
                  });

                  selectedHubsData.map((hub) => {
                    if (selectedFleetCodes?.includes(hub.fleetCode)) {
                      if (mp[hub.fleetCode] === undefined)
                        mp[hub.fleetCode] = [];
                      mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                    }
                  });

                  setFleetMap(mp);
                  setSelectedHubs(value.map((hub) => hub.value));
                }
              }}
              name="hubs"
              isMulti={true}
            />
          </label>
          <label className="w-full ">
            Contract Type
            <ReactSelect
           styles={{
            control: (base, state) => ({
              ...base,
              borderColor: 'transparent',
              minWidth: '100%',
              '&:hover': {
                borderColor: 'rgb(34 197 94)',
              },
            }),
          }}
            name="contractType"
            className="shadow-md rounded-md py-1 mb-2"
            value={contractTypeOptions.find(option => option.value === contractType)}
            onChange={(option) => {
              setContractType(option.value); // Store only the value
            }}
            options={contractTypeOptions}
          />
          </label>
        </div>

        <div className="w-full px-8 flex justify-start mt-2 items-center gap-4">
        <label className="">
            Report Type 
            <Select
              name="reportType"
              value={reportType}
              onChange={(e) => {
                setReportType(e.target.value);
              }}          
            >
              <option value={"fleet"}>Fleet Wise</option>
              <option value={"hub"}>Hub Wise</option>
            </Select>
          </label>
   
          <label>
            Start Date{" "}
            <Input
              type="date"
              max={getFormattedDate()}
              name="dateFrom"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </label>
          <label>
            End Date{" "}
            <Input
              type="date"
              min={getFormattedDate(dateFrom)}
              name="dateTo"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </label>
          <Button
            type="button"
            className='mt-5'
            bgPrimary
            onClick={() => {
              getData();
            }}
          
            disabled={!selectedHubs.length}
          >
            Search
          </Button>
          {downloading
            ? "Downloading..."
            : selectedHubs.length > 0 && (
                <BiCloudDownload
                  className="w-10 mt-5 h-10 text-green-500 hover:scale-105 cursor-pointer text-center"
                  onClick={() => {
                    getDownloadData();
                  }}
                />
              )}
        </div>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col my-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                {data?.dateRange && (
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <TH scope="col">S.N.</TH>
                        <TH scope="col">Fleet Name</TH>
                        {showHubColumn && <TH scope="col">Hub Name</TH>}
                        <TH scope="col">Enrolled Vehicles</TH>
                        {data.dateRange.map((date) => (
                          <TH scope="col">
                            <div className="text-center">
                              {`${allMonths[parseInt(date.split("-")[0])]}-${
                                date.split("-")[1]
                              }`}
                            </div>
                          </TH>
                        ))}
                        <TH scope="col">Inspection %</TH>
                        <TH scope="col">Total Vehicles</TH>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {data.inspections &&
                        data.inspections?.map((d, idx) => (
                          <ViewList
                            data={d}
                            idx={idx}
                            months={data.dateRange}
                            dateFrom={searchPayload?.dateFrom ?? dateFrom}
                            dateTo={searchPayload?.dateTo ?? dateTo}
                            reportType={searchPayload?.reportType ?? reportType}
                            contractType={searchPayload?.contractType ?? contractType}
                            showHubColumn={showHubColumn}
                            total={data.fleetEnrolledMap[d.fleetId] ?? 1}
                            selectedHubs={searchPayload?.hubs}
                          />
                        ))}
                    </tbody>
                    <tfoot>
                      {data?.totalRow ? (
                        <tr className="text-gray-600 font-semibold bg-green-100">
                          <TD></TD>
                          <TD colSpan={showHubColumn ? 2 : 1} className="text-left">
                            TOTAL
                          </TD>
                          <TD className="">
                            {data.totalRow.enrolledVehicles ?? data.totalRow.vehicleCount ?? 0}
                          </TD>
                          {data.dateRange.map((date) => (
                            <TD scope="col" className="text-center">
                              {data.totalRow[date]}
                            </TD>
                          ))}
                          <TD>{parseFloat(data.totalRow?.averagePercent) > 100 ? "100" : data.totalRow?.averagePercent}</TD>
                          <TD className="">
                            {data.totalRow.totalVehicles ?? 0}
                          </TD>
                        </tr>
                      ) : (
                        <></>
                      )}
                    </tfoot>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InspectionDetailsInLastFourMonths;

const ViewList = ({ data, idx, months, dateFrom, dateTo, total, reportType, contractType, showHubColumn, selectedHubs}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [isLoading, setIsLoading] = useState(true)
  const[selectedMonthYear,setSelectedMonthYear]=useState("");
  const [modalQueryProp, setModalQueryProp] = useState(null);const modalHandler = useCallback(
    (vehicles) => {
      if (vehicles) {
        setModalData(vehicles);
        setShowModal(true);
      } else {
        setShowModal(false);
        setModalData([]);
      }
    },
    [showModal, modalData]
  );
  const getModalData = async (modalQueryProp, selectedMonthYear,title,fleetId,hubId) => {
    console.log('modalQueryProp--',modalQueryProp);
    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      return;
    }
    setShowModal(true)
    if (modalQueryProp) {
      setIsLoading(true);
      const hubsToSend = Array.isArray(modalQueryProp?.data?.hubId)
        ? modalQueryProp.data.hubId.join(",")
        : modalQueryProp?.data?.hubId || modalQueryProp?.hubId || selectedHubs;

      const dt = await createDocument("/report/inspectionDetailsInLastFourMonths/modalInfo", 
        {
          dateFrom: modalQueryProp.dateFrom, 
          dateTo: modalQueryProp.dateTo,
          fleets: modalQueryProp?.fleetId,
          hubs: hubsToSend,
          reportType: modalQueryProp?.reportType,
          contractType: modalQueryProp?.contractType,
          selectedMonthYear:modalQueryProp?.selectedMonthYear
      }
   );

    console.log('getModal--',dt);

      if (dt?.inspections) {
        setModalData(dt?.inspections)
        setModalQueryProp(modalQueryProp);
      }
  }
  setIsLoading(false);
}
// console.log("MDD T", modalData)

console.log('data--',data)

  // console.log("month info", data[months[months.length - 1]], data.enrolledVehicles)
  return (
    <Fragment>
      {showModal && (
        <Modal
          handleClick={() => setShowModal(false)}
          title={modalQueryProp?.title}
          className="max-w-2xl"
        >
          {/* <h1>This is the modal</h1> */}
          {isLoading ? <Spinner /> : <>
            <h1 className="w-full flex justify-end text-end px-2 my-1">
            <Button
              onClick={() => {
                exportExcel(
                  modalData?.map((x, idx) => ({
                    "S.N": idx + 1,
                    "Fleet Name": `${data?.fleet} (${data?.fleetCity || "-"})`,
                    "Vehicle Reg No.": x?.registrationNumber,
                    "Inspected By": x?.inspectedBy,
                    "Last Inspection Date": x?.inspectionDate,
                  })),
                  modalQueryProp.title.split(" ").join("_") + "_Data"
                );
              }}
              className=" text-blue-500 hover:scale-105 cursor-pointer text-right"
            >
              Download
            </Button>
          </h1>
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <TH scope="col">S.N.</TH>
                <TH scope="col">Vehicle Number</TH>
                <TH scope="col">Contract Type</TH>
                <TH scope="col">Inspected By</TH>
                <TH scope="col">Last Inspection Date</TH>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {modalData &&
                modalData.length > 0 &&
                modalData.map((vehicle, index) => (
                  <tr>
                    <TD>{index + 1}</TD>
                    <TD>{vehicle.registrationNumber}</TD>
                    <TD>{vehicle.contract}</TD>
                    <TD>{vehicle.inspectedBy}</TD>
                    <TD>{vehicle.inspectionDate}</TD>
                  </tr>
                ))}
            </tbody>
          </table>
          </>}
        </Modal>
      )}
      <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{idx + 1}</TD>
        <TD>{`${data?.fleet} (${data?.fleetCity || "-"})`}</TD>
        {showHubColumn && <TD scope="col">{data.hubName}</TD>}
        <TD>{data?.enrolledVehicles ?? 0}</TD>
        {months &&
          months.length > 0 &&
          months.map((month) => (
            <TD>
              <div className="flex gap-2 items-center justify-center">
                <span
                  className="hover:text-green-500 cursor-pointer"
                  onClick={() => getModalData({
                    data,
                    dateFrom, contractType, dateTo,
                    selectedMonthYear: month,
                    title: "Inspection Details " + data.fleet + " (" + (data?.fleetCity || "-") + ") " + month,
                    fleetId: data?.fleetId,
                    hubId: data?.hub, 
                    reportType
                  })}                >
                  {data[month] ?? 0}
                </span>
              </div>
            </TD>
          ))}
        <TD>


        {(() => {
          const lastMonthCount = data[months[months.length - 1]] ?? 0;
          const denominator = data?.enrolledVehicles || total;
          if (!lastMonthCount || !denominator) return "0";
          const pct = (lastMonthCount / denominator) * 100;
          return pct > 100 ? "100" : pct.toFixed(2);
        })()}

        </TD>
        <TD>{data?.totalVehicles ?? 0}</TD>
      </tr>
    </Fragment>
  );
};
